<div class="d-flex w-100 align-items-center justify-content-center" style="min-height: 150px">
  <div class="d-flex justify-content-center" style="flex-direction: column">
    <img src="assets/images/miscellaneus/no-data.png" alt="no-data" width="100" height="80"><br>
    <span class="text-primary">{{message}}</span>
  </div>
</div>